/**
 * Preferencia de ocultar el menú lateral en escritorio. [NUEVO 20/10/2026]
 *
 * Se guarda por navegador (localStorage), nunca por usuario ni en el backend.
 * Por defecto el menú está visible: sin preferencia guardada, o con el
 * almacenamiento bloqueado (ventana privada, sitio sin permiso), la pantalla se
 * ve exactamente como antes.
 */
export const CLAVE_MENU_OCULTO = "cfe-review:menu-oculto";

export interface AlmacenSimple {
  getItem(clave: string): string | null;
  setItem(clave: string, valor: string): void;
}

export function leerMenuOculto(almacen: AlmacenSimple | null): boolean {
  try {
    return almacen?.getItem(CLAVE_MENU_OCULTO) === "1";
  } catch {
    return false;
  }
}

export function guardarMenuOculto(almacen: AlmacenSimple | null, oculto: boolean): void {
  try {
    almacen?.setItem(CLAVE_MENU_OCULTO, oculto ? "1" : "0");
  } catch {
    // Sin almacenamiento la preferencia dura solo mientras la pestaña esté abierta.
  }
}
